import { render, staticRenderFns } from "./organDetailAll.vue?vue&type=template&id=1496ffd5&scoped=true&"
import script from "./organDetailAll.vue?vue&type=script&lang=ts&"
export * from "./organDetailAll.vue?vue&type=script&lang=ts&"
import style0 from "./organDetailAll.vue?vue&type=style&index=0&id=1496ffd5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1496ffd5",
  null
  
)

export default component.exports